export default "__VITE_ASSET__ChtuR6pd__"